<template>
  <b-form-group
    label="Gelir & Gider"
    label-for="id_types"
  >
    <v-select
      id="id_types"
      v-model="filterParams.id_types"
      :options="typeList"
      label="title"
      :reduce="item => item.value"
      placeholder="Tümü"
      @input="getDonationGroups"
    />
  </b-form-group>
</template>
<script>
import vSelect from 'vue-select'
import { BFormGroup } from 'bootstrap-vue'

export default {
  name: 'TypeSelect',
  components: {
    BFormGroup,
    vSelect,
  },
  data() {
    return {
      typeList: [
        {
          title: 'Gelir',
          value: 'is_income',
        },
        {
          title: 'Gider',
          value: 'is_expense',
        },
      ],
    }
  },
  computed: {
    filterParams() {
      return this.$store.getters['accountActivities/filterParams']
    },
  },
  methods: {
    getDonationGroups() {
      let where = {}
      if (this.filterParams.id_types === 'is_income') {
        where = {
          'donation_groups.is_income !=': null,
          'donation_groups.is_expense': null,
        }
      }
      if (this.filterParams.id_types === 'is_expense') {
        where = {
          'donation_groups.is_expense !=': null,
          'donation_groups.is_income': null,
        }
      }
      this.filterParams.id_donation_groups = null
      this.$store.dispatch('donationGroups/getDataList', {
        select: [
          'donation_groups.id AS id',
          'donation_groups.title AS title',
          'main_group.title AS main_group',
          'donation_groups.is_income AS is_income',
          'donation_groups.is_expense AS is_expense',
        ],
        where,
      })
    },
  },
}
</script>
